/**
 * Route guard — redirects non-admin users away from admin-only pages.
 *
 * Used to protect `/admin/codes-rd` (matricules subsystem). Kept small
 * and route-scoped so we don't refactor the existing admin routes
 * without an explicit request — CEO brief 2026-07-27 §1 point 1:
 * "je ne toucherai à aucune fonctionnalité existante hors du périmètre".
 *
 * Usage:
 *   <Route path="/admin/codes-rd" element={
 *       <RequireAdmin>
 *           <CodeRdAdmin />
 *       </RequireAdmin>
 *   } />
 */
import { Navigate } from "react-router-dom";

import { useAuth } from "../../lib/auth";
import { hasRole } from "../../lib/roles";


export default function RequireAdmin({ children }) {
    const { user, loading } = useAuth();
    // While the auth state hydrates from local storage, don't flash the
    // redirect — otherwise a legitimate admin briefly sees /dashboard
    // before landing on the admin page.
    if (loading) {
        return (
            <div
                data-testid="require-admin-loading"
                className="min-h-screen flex items-center justify-center text-slate-400 text-sm"
            >
                Chargement…
            </div>
        );
    }
    if (!user || !hasRole(user, "admin")) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
